import { ThemeUICSSObject } from '@apia/theme';
import modal from './modal';
import buttons from './buttons';
import verify from './verify';
/* IMPORT HERE */

const digitalSign: ThemeUICSSObject = {
  modal,
  buttons,
  verify,
  /* PREPEND HERE */
};

export default digitalSign;
